import React from "react";
import {Component} from 'react'

import {Nav, Navbar} from 'react-bootstrap';

import logo from '../inc/img/Logo.png';
import CMEC_logo_PMS from '../inc/img/CMEC_logo_PMS.jpg';


class Header extends Component {



  RefreshLink(props){
    if (props.showRefreshBtn === true){
      return (
        <>
          <button className="refreshBtn"
            onClick={function(){document.getElementById("RessourceIframe").src = document.getElementById("RessourceIframe").src;}}
          >
            <span className="fa fa-refresh" aria-hidden="true"></span>
            <span className="text">Rafraîchir la page<br/>une fois authentifié</span>
          </button>
        </>
      )
    }

  }
  render() {
    return (
      <header className="header">

        <Navbar collapseOnSelect expand="lg">
          <Navbar.Brand href="/"><img src={logo} alt="Accueil" /></Navbar.Brand>
          {this.RefreshLink(this.props)}
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
            </Nav>
            <Nav>
              <Nav.Link href="/Ateliers"><span className="fas fa-presentation pr-2" aria-hidden="true"></span>Les ateliers</Nav.Link>
              <Nav.Link href="/Recherche">Recherche</Nav.Link>
              <Nav.Link href="/PlanDuSite">Plan du site</Nav.Link>
              <Nav.Link href="/NousJoindre">Nous joindre</Nav.Link>
              <Nav.Link href="https://lien.cforp.ca/24694" target="_blank">Votre avis</Nav.Link>
              <Nav.Link href="/AutresRessources">Autres ressources</Nav.Link>
            </Nav>
            <Nav.Link href="https://cmec.ca/41/Au_sujet_du_CMEC.html" target="_blank"><img src={CMEC_logo_PMS} alt="Logo CMEC" /></Nav.Link>
          </Navbar.Collapse>
        </Navbar>
      </header>
    );
  }
}
export default Header;
